import { colors } from "@obs/tokens/index.stylex.ts";
import * as stylex from "@stylexjs/stylex";

import { ButtonPrimitive, type ButtonPrimitiveProps } from "../primitives/ButtonPrimitive";

const styles = stylex.create({
	root: {
		backgroundColor: {
			default: "transparent",
			":hover:not(:disabled)": colors.neutralBgDefaultActive,
			":active:not(:disabled)": colors.neutralBgWeak,
			":disabled": "transparent",
		},
		color: {
			default: colors.accentTxtDefault,
			":disabled": colors.disabledTxtDefault,
		},
	},
});

export function Tertiary(props: ButtonPrimitiveProps) {
	return <ButtonPrimitive {...props} sx={[styles.root, props.sx]} />;
}
